// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__GxC9g","buttonContainer":"Home_buttonContainer__UHQVC","button":"Home_button__1gOAx","footer":"Home_footer__cVD-L"};